module.exports = __webpack_public_path__ + "static/media/kuaraLogoBGUp.8b6c9ee0.svg";